export default "__VITE_ASSET__D72q0iI9__"